export default {"src":"/_next/static/media/0x0AaCfbeC6a24756c20D41914F2caba817C0d8521.1034a066.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};